import { withProps } from 'recompose'
import CarTile from './CarTile'

export default withProps(({ makeDesc, modelDesc, subModelDesc }) => ({
  model: `${makeDesc} ${modelDesc} ${subModelDesc}`
}))(CarTile)
